import { Grid } from '@material-ui/core';
import PageTitle from 'components/base/title/PageTitle';
import MuiButton from 'components/common/button/MuiButton';
import ListEmpty from 'components/common/list/ListEmpty';
import CustomPagination from 'components/common/pagination/CustomPagination';
import CustomSpan from 'components/common/text/CustomSpan';
import T from 'components/common/text/T';
import { ProjectContext } from 'contexts/project/ProjectContext';
import { pageUrl } from 'lib/mapper';
import { OffsetPagingData } from 'lib/types/sharedTypes';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useShallowAppSelector } from 'store/hooks';
import styled from 'styled-components';
import ProjectCard from './ProjectCard';
import ProjectListSkeleton from './ProjectListSkeleton';
import ProjectSearchFilter, { ProjectSearchFilterProps } from './ProjectSearchFilter';

export interface ProjectListProps extends ProjectSearchFilterProps {
  isLoadSuccess: boolean;
  isLoadFailure: boolean;
  projects: object | any | null;
  projectsPagingData: OffsetPagingData | null;
  page: { value: number; onChange: (e: any) => void; setValue: (value: number) => void };
  onDeleteProject: (pcode: string) => void;
  patientCode: string | null;
  onRefreshList: () => void;
  onChangeProjectProcess: (id: number) => void;
  onCheckAllStage: (checkAll: boolean) => void;
  onChangeDate: (e: any) => void;
}

function ProjectList({
  isLoadSuccess,
  isLoadFailure,
  projects,
  projectsPagingData,
  period,
  checkedProjectProcess,
  keyword,
  onChangePage,
  onSearch,
  page,
  onDeleteProject,
  patientCode,
  onRefreshList,
  onChangeProjectProcess,
  onCheckAllStage,
  onChangeDate,
}: ProjectListProps) {
  const { projectsPending }: { projectsPending: boolean } = useShallowAppSelector(state => ({
    projectsPending: state.project.projects.pending,
  }));
  const history = useHistory();
  const { reworkProjectCode } = useContext(ProjectContext);
  const { t } = useTranslation();

  return (
    <Styled.ProjectList data-component-name="ProjectList">
      {!patientCode && (
        <PageTitle title={t('NAV_MENU_PROJECT')} className="projectList__title_box" />
      )}
      <Grid container className="projectList__container">
        <Grid item container justifyContent="space-between" xs={12} className="projectList__top">
          <div className="projectList__btn_box">
            <MuiButton
              disableElevation
              variant="contained"
              color="primary"
              className="lg projectList__create_btn inset-shadow-default border-radius-round"
              onClick={() => {
                reworkProjectCode.setValue(null);
                history.push(pageUrl.project.create.new);
              }}
            >
              <CustomSpan fontSize={18} fontWeight={400}>
                {'+ '}
                <T>GLOBAL_CREATE_PROJECT</T>
              </CustomSpan>
            </MuiButton>
          </div>
          <ProjectSearchFilter
            period={period}
            checkedProjectProcess={checkedProjectProcess}
            keyword={keyword}
            onChangePage={onChangePage}
            onSearch={onSearch}
            onChangeProjectProcess={onChangeProjectProcess}
            onCheckAllStage={onCheckAllStage}
            onChangeDate={onChangeDate}
            isPatient={!!patientCode}
          />
        </Grid>

        <Grid item xs={12} className="projectList__middle">
          <Grid container className="projectList__card_wrapper">
            {!isLoadSuccess &&
              // <div className="infinite-scroll-loading">
              //   <CircularLoading />
              // </div>
              Array.from({ length: 8 }, (_, index) => <ProjectListSkeleton key={index} />)}
            {!!isLoadSuccess &&
              (projects?.length > 0 ? (
                projects.map((item: any, idx: number) => {
                  if (idx >= 8) return null;
                  return <ProjectCard key={idx} data={item} onDeleteProject={onDeleteProject} />;
                })
              ) : (
                <ListEmpty text="GLOBAL_EMPTY_LIST_PROJECT" />
              ))}
            {!!isLoadFailure && (
              <ListEmpty
                text="GLOBAL_LIST_ERROR"
                isRefreshButton={true}
                onRefresh={onRefreshList}
              />
            )}
          </Grid>
          {!!isLoadSuccess && projects?.length > 0 && !!projectsPagingData?.totalPage && (
            <CustomPagination
              totalPage={projectsPagingData?.totalPage}
              currPage={page.value}
              onChange={onChangePage}
            />
          )}
        </Grid>
      </Grid>
    </Styled.ProjectList>
  );
}

const Styled = {
  ProjectList: styled.section`
    width: 100%;
    .projectList__container {
      width: 100%;
      margin-top: 20px;
      > .MuiGrid-item {
      }
      .projectList__top {
        position: relative;
        width: 100%;

        .projectList__btn_box {
          position: absolute;
          z-index: 2;
          top: -4px;
          right: 0;
          .projectList__create_btn {
            width: 392px;
            height: 54px;
            svg {
              margin-right: 5px;
            }
          }
        }
      }
      .projectList__middle {
        .projectList__card_wrapper {
          column-gap: 26px;
          row-gap: 20px;
          margin-top: 20px;
          margin-bottom: 30px;
          width: 100%;
          height: 680px;
          position: relative;
        }
      }
    }
  `,
};

export default React.memo(ProjectList);
